import { Link } from 'react-router-dom';
import '../css/style.css';
import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';

class Footer extends Component {
 constructor(props) {
    super(props);
    this.state = {
      
    };
    
    
   
  }

  componentDidMount() {
    // Add event listeners
   

  }

  

    
      render() {
        return (
            <footer className="footer">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 mb-4">
                <div className="footer-logo orbitron">Sterling Surveillance Technologies LTD</div>
                <p className="text-muted">A Canadian-owned and operated leader in security and surveillance solutions, delivering intelligent, technology-driven protection through expertly trained personnel. Specializing in safeguarding properties, projects, and people across major cities and surrounding regions with a commitment to reliability, professionalism, and peace of mind.</p>
              </div>
              <div className="col-lg-2 col-md-6 mb-4">
                <h6 className="text-light mb-3">Services</h6>
                <div className="footer-links">
                  <a href="/services/remote-monitoring">Live Video Monitoring & Security</a>
                  <a href="/services/remote-concierge">Remote Concierge Services</a>
                  <a href="/services/remote-access-management">Remote Access Management</a>
                  <a href="/services/time-lapse-monitoring">Time Lapse Video Monitoring</a>
                  <a href="/services/ai-powered-security">AI Powered Security</a>

                </div>
              </div>
              <div className="col-lg-2 col-md-6 mb-4">
                <h6 className="text-light mb-3">Company</h6>
                <div className="footer-links">
                  <a href="/about">About Us</a>
                  {/* <a href="#">Our Team</a>
                  <a href="#">Careers</a> */}
                  <a href="/policy">Privacy Policy</a>
                  <a href="/terms">Terms of Service</a>
                  <a href="/contact">Contact</a>
                </div>
              </div>
              <div className="col-lg-4 mb-4">
                <h6 className="text-light mb-3">Contact Info</h6>
                <div className="text-muted">
<div className="mb-2 secondary-color">
      <span>British Columbia Office</span><hr></hr>
      <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2" />
      138, Unit 8 – 6014 Vedder Road, Chilliwack, BC V2R 5P5<br />
      <FontAwesomeIcon icon={faPhone} className="me-2" />
      +1 (604) 343-5245
    </div>
<br />
    <div className="mb-2 mt-3 secondary-color">
      <span>Alberta Office</span><hr></hr>
      <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2" />
      Suite 315 – 919 Centre Street NW, Calgary, AB T2E 2P6<br />
      <FontAwesomeIcon icon={faPhone} className="me-2" />
      +1 (403) 992-1672
    </div>

    <div className="mb-2 mt-3 secondary-color">
      <FontAwesomeIcon icon={faEnvelope} className="me-2" />
      info@sterlingtechnologies.ca
    </div>

    <div className="mb-2 mt-3 secondary-color">
      <div style={{float:"left",width: "150px",backgroundColor: "#fff", padding:"8px 12px"}}>
      <span style={{width:"76px",float: "left",color: "#000", fontSize: "12px", fontWeight:"bold"}}>CANADIAN OWNED & OPERATED</span>
      <img style={{width: "50px"}} src='../images/ml.png' alt="canadian owned and operated"/>
      </div>
    </div>
                  {/* <div className="mb-2"><i className="fas fa-map-marker-alt me-2"></i>123 Security St, Vancouver, BC</div>
                  <div className="mb-2"><i className="fas fa-phone me-2"></i>(604) 555-0123</div>
                  <div className="mb-2"><i className="fas fa-envelope me-2"></i>support@sterlingtechnologies.ca.com</div> */}
                </div>
              </div>

              {/* <div className="col-lg-4 mb-4">
  <h6 className="text-light mb-3">Contact Info</h6>
  <div className="text-muted">

    <div className="mb-2">
      <strong>British Columbia Office</strong><br />
      <i className="fas fa-map-marker-alt me-2"></i>138, Unit 8 – 6014 Vedder Road, Chilliwack, BC V2R 5P5<br />
      <i className="fas fa-phone me-2"></i>+1 (403) 992-1672
    </div>

    <div className="mb-2 mt-3">
      <strong>Alberta Office</strong><br />
      <i className="fas fa-map-marker-alt me-2"></i>Suite 315 – 919 Centre Street NW, Calgary, AB T2E 2P6<br />
      <i className="fas fa-phone me-2"></i>403-992-1672
    </div>

    <div className="mb-2 mt-3">
      <i className="fas fa-envelope me-2"></i>support@sterlingtechnologies.ca
    </div>

  </div>
</div> */}



            </div>
            <hr className="my-4" style={{borderColor: '#ffffff'}} />
            <div className="row">
              <div className="col-md-6">
                <p className="text-muted mb-0">&copy; 2025 Sterling Surveillance Technologies. All rights reserved.</p>
              </div>
              {/* <div className="col-md-6 text-md-end">
                <div className="footer-links d-inline">
                  <a href="#" className="me-3">Privacy Policy</a>
                  <a href="#" className="me-3">Terms of Service</a>
                  <a href="#">Sitemap</a>
                </div>
              </div> */}
            </div>
          </div>
        </footer>
        );
        }
    }

export default Footer;
